import * as React from 'react';
import { isNull } from 'lodash';
// constants
import { CATEGORY } from 'modules/analytics-provider/analytics-provider.constants';
import { LOGIN_FLOW_STEP, LOGIN_FLOW_ACTIONS } from './login.constants';
// service
import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';
// components
import Spinner from 'components/spinner/spinner.component';
import LoginPopin from 'modules/login/login-popin/login-popin.component';
import LoginPopup from 'modules/login/login-popup';
import { ILoginProps } from 'modules/login/login.types';

export default class Login extends React.Component<ILoginProps, {}> {
    public componentDidMount() {
        const {
            additionalAnalyticsInfo = {},
            getThirdPartyStatus,
            setUpLoginSessionCallback
        } = this.props;
        setUpLoginSessionCallback();
        getThirdPartyStatus();

        // Move out to particular component
        if (!AnalyticsService.isAuthenticatedUser) {
            AnalyticsService.sendFlowEvent({
                ...LOGIN_FLOW_STEP,
                ...additionalAnalyticsInfo,
                action: LOGIN_FLOW_ACTIONS.DISPLAY,
                category: CATEGORY.DISPLAY
            });
        }
    }

    public render() {
        const { hasTPCEnabled } = this.props;

        if (isNull(hasTPCEnabled)) {
            return <Spinner />;
        }

        return hasTPCEnabled ? <LoginPopin {...this.props}/> : <LoginPopup {...this.props}/>;
    }
}
